/**
 * スムーズスクロール設定
 * ページ内アンカーリンククリック時に固定ヘッダーを考慮してスムーズスクロール
 */
export const smoothScroll = {
  init: () => {
    const anchorLinks = document.querySelectorAll<HTMLAnchorElement>(
      'a[href^="#"]:not([href="#"])'
    );

    anchorLinks.forEach((link) => {
      link.addEventListener('click', (e) => {
        const href = link.getAttribute('href');
        if (!href) return;

        const targetId = href.slice(1);
        const target = document.getElementById(targetId);
        if (!target) return;

        e.preventDefault();

        const header = document.getElementById('header');
        let offset = 0;
        if (header) {
          const style = window.getComputedStyle(header);
          const position = style.position;
          if (position === 'fixed' || position === 'sticky') {
            offset = header.offsetHeight;
          }
        }

        const targetTop =
          target.getBoundingClientRect().top + window.pageYOffset - offset;
        window.scrollTo({
          top: targetTop,
          behavior: 'smooth',
        });
      });
    });
  },
};
